export default __webpack_public_path__ + "static/media/dec3097a-bd68-4f2a-a11c-65c0ace2580e.76cbd43c.jfif";